<template>
  <div>
    <!-- 1. KHU VỰC HIỂN THỊ ẢNH THU NHỎ (Có thể click để mở modal) -->
    <div
      @click="handleClickImage"
      :style="smallImageWrapperStyle"
      class="clickable-image-wrapper"
    >
      <img
        :src="currentImageSrc"
        class="img-thumbnail"
        alt="Ảnh đại diện"
        :style="{
          'max-width': '100%',
          'height': '100%',
          'border-radius': '8px',
          'object-fit': 'cover',
          'max-height': maxPreviewHeight // <--- ÁP DỤNG PROP MỚI TRỰC TIẾP LÊN ẢNH
        }"
      />
    </div>

    <!-- 2. Modal hiển thị ảnh lớn (Đã thêm nút điều khiển Zoom) -->
    <b-modal
      v-model="showImageModal"
      :title="'Phóng to ảnh'"
      size="xl"
      modal-class="modal-dialog-centered image-zoom-modal"
      hide-footer
      centered
      @shown="resetZoom"
    >
      <!-- CONTAINER ẢNH CÓ THỂ ZOOM -->
      <div class="image-container-zoom d-flex justify-content-center mb-2">
        <img
          :src="currentImageSrc"
          :style="{
            transform: `scale(${imageScale})`,
            transition: 'transform 0.2s ease-out',
            'max-height': maxModalImageHeight, /* Áp dụng giới hạn modal */
          }"
          class="zoomable-image"
          alt="Ảnh xem trước"
        />
      </div>

      <!-- KHU VỰC ĐIỀU KHIỂN ZOOM -->
      <div class="zoom-controls d-flex justify-content-center mb-3">
        <b-button size="sm" class="me-2" @click="zoomIn">
          <i class="fas fa-search-plus"></i> Phóng to
        </b-button>
        <b-button size="sm" class="me-2" @click="zoomOut">
          <i class="fas fa-search-minus"></i> Thu nhỏ
        </b-button>
        <b-button size="sm" @click="resetZoom">
          <i class="fas fa-undo"></i> Đặt lại
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ZoomableImage",
  props: {
    canClick: {
      type: Boolean,
      default: true,
    },
    // Full URL của ảnh (url + fileId)
    currentImageSrc: {
      type: String,
      required: true,
    },
    // Style tùy chỉnh cho thẻ DIV wrapper ảnh nhỏ
    smallImageWrapperStyle: {
      type: Object,
      default: () => ({
        cursor: "pointer",
        "margin-right": "0",
      }),
    },
    // NEW: Chiều cao tối đa của ảnh preview thu nhỏ (Áp dụng lên thẻ <img>)
    maxPreviewHeight: {
        type: String,
        default: '200px' // Mặc định là 200px
    },
    // Chiều cao tối đa của ảnh khi hiển thị trong modal (trước khi zoom)
    maxModalImageHeight: {
        type: String,
        default: '500px' // Mặc định là 500px, bạn có thể chỉnh
    }
  },
  data() {
    return {
      showImageModal: false,
      // State cho Zoom
      imageScale: 0.9, // Tỉ lệ phóng to/thu nhỏ mặc định
      zoomStep: 0.2, // Bước nhảy của zoom
      minScale: 0.5, // Tỉ lệ thu nhỏ tối thiểu
      maxScale: 3.0, // Tỉ lệ phóng to tối đa
    };
  },
  methods: {
    // Hàm xử lý click vào ảnh để mở modal
    handleClickImage() {
      if (this.currentImageSrc && this.canClick) {
        this.showImageModal = true;
      }
    },
    // Hàm xử lý Zoom In
    zoomIn() {
      if (this.imageScale < this.maxScale) {
        this.imageScale = Math.min(
          this.maxScale,
          this.imageScale + this.zoomStep
        );
      }
    },
    // Hàm xử lý Zoom Out
    zoomOut() {
      if (this.imageScale > this.minScale) {
        this.imageScale = Math.max(
          this.minScale,
          this.imageScale - this.zoomStep
        );
      }
    },
    // Hàm xử lý Reset Zoom
    resetZoom() {
      this.imageScale = 0.9;
    },
  },
};
</script>

<style scoped>
/* Style cho modal (nếu cần custom thêm) */
.image-zoom-modal .modal-content {
  border-radius: 10px;
  max-width: 100%;
}

/* Ẩn overflow để khi zoom không làm cuộn màn hình chính */
.image-container-zoom {
  overflow: hidden;
}

.img-thumbnail{
    display: inline-block;
}

/* Đặt ảnh lớn để nó có thể được zoom */
.zoomable-image {
  max-width: 100%;
  height: auto;
  /* Dùng transform để zoom, không làm thay đổi layout */
  transform-origin: center center;
  cursor: default;
}
/* Style cho wrapper ảnh nhỏ để đảm bảo con trỏ chuột là pointer */
.clickable-image-wrapper {
  cursor: pointer;
  /* Đảm bảo chiều cao ảnh nhỏ được set đúng qua prop style */
  display: inline-block;
}
</style>